import { TYPES } from "./cashup.type";

const initState = {
  income: null,
  branch: null,
  userInfo: null,
  detail: null,
  all: null,
};

const cashupReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_INCOME_SUCCESS:
      return {
        ...state,
        income: payload,
      };
    case TYPES.SELECT_ALL_BRANCH_SUCCESS:
      return {
        ...state,
        branch: payload,
      };
    case TYPES.SELECT_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: payload,
      };

    case TYPES.SELECT_DETAIL_CASHUP:
      return {
        ...state,
        detail: payload,
      };
    case TYPES.SELECT_ALL_CASHUP:
      return {
        ...state,
        detail: payload,
      };

    default:
      return state;
  }
};

export default cashupReducer;
